import { OnPageSubnav } from '../modules/on-page-subnav';

const subnav = document.querySelector('[data-subnav]') as HTMLElement;
if (!!subnav) {
    new OnPageSubnav(subnav);
}